/*eslint-disable*/
import React, { useState } from 'react';
import PropTypes from 'prop-types'
// components
import {
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ResetPassword from '../../../../../../components/resetPassword';
import ForgotPassword from '../../../../../../components/forgotPassword';
import SendActivationEmail from '../../../../../../components/sendActivationEmail';
import SendReActivationEmail from '../../../../../../components/sendReActivationEmail';
import ResetMultiFactor from '../../../../../../components/resetMultiFactor';

// helpers
import {
  getEmail, shouldEnableForgotPassword, shouldEnableSendActivationEmail,
  shouldEnableResetPassword, shouldEnableSendReActivationEmail,
  shouldEnableResetMultiFactor
} from '../../../../../../helpers/users';

// hooks
import useDialogVisibility from '../../../../../../hooks/useDialogVisibility';

const KebabMenu = ({ user }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [
    isResetPasswordDialogOpen,
    openResetPasswordDialog,
    closeResetPasswordDialog,
  ] = useDialogVisibility(false);
  const [
    isSendActivationEmailDialogOpen,
    openSendActivationEmailDialog,
    closeSendActivationDialog,
  ] = useDialogVisibility(false);
  const [
    isSendReActivationEmailDialogOpen,
    openSendReActivationEmailDialog,
    closeSendReActivationDialog,
  ] = useDialogVisibility(false);
  const [
    isResetMultiFactorDialogOpen,
    openResetMultiFactorDialog,
    closeResetMultiFactorDialog,
  ] = useDialogVisibility(false);
  const [
    isForgotPasswordDialogOpen,
    openForgotPasswordDialog,
    closeForgotPasswordDialog,
  ] = useDialogVisibility(false);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSendActivationEmail = (event) => {
    event.stopPropagation();
    openSendActivationEmailDialog();
    handleMenuClose();
  };

  const handleResetMultiFactor = (event) => {
    event.stopPropagation();
    openResetMultiFactorDialog();
    handleMenuClose();
  };

  const handleSendReActivationEmail = (event) => {
    event.stopPropagation();
    openSendReActivationEmailDialog();
    handleMenuClose();
  };

  const handleResetPassword = (event) => {
    event.stopPropagation();
    openResetPasswordDialog()
    handleMenuClose();
  };

  const handleForgotPassword = (event) => {
    event.stopPropagation();
    openForgotPasswordDialog()
    handleMenuClose();
  };

  return (
    <>
      <div>
        <IconButton
          aria-label="kebab-menu"
          size="small"
          style={{
            padding: '0',
            '&:hover': {
              backgroundColor: 'white',
            },
          }}
          onClick={handleMenuClick}
          data-testid="menu-icon"
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          data-testid="menu"
        >
          {shouldEnableSendActivationEmail(user) &&
          <MenuItem data-testid="userListSendActivationEmail" onClick={handleSendActivationEmail}>Send Activation Email</MenuItem>}
          {shouldEnableForgotPassword(user) &&
          <MenuItem data-testid="userListForgotPassword" onClick={handleForgotPassword}>Forgot Password</MenuItem>}
          {shouldEnableResetPassword(user) &&
          <MenuItem data-testid="userListResetPassword" onClick={handleResetPassword}>Reset Password</MenuItem>}
          {shouldEnableSendReActivationEmail(user) &&
          <MenuItem data-testid="userListSendReActivationEmail" onClick={handleSendReActivationEmail}>Send re-activation Email</MenuItem>}
          {shouldEnableResetMultiFactor(user) &&
          <MenuItem data-testid="userListResetMultiFactor" onClick={handleResetMultiFactor}>Reset Multi Factor</MenuItem>}
        </Menu>
      </div>
      <ResetPassword
        showModal={isResetPasswordDialogOpen}
        handleClose={closeResetPasswordDialog}
        userId={user.id}
      />
      <ForgotPassword
        showModal={isForgotPasswordDialogOpen}
        handleClose={closeForgotPasswordDialog}
        userId={user.id}
        userEmail={getEmail(user)}
      />
      <SendActivationEmail
        showModal={isSendActivationEmailDialogOpen}
        handleClose={closeSendActivationDialog}
        userId={user.id}
        userEmail={getEmail(user)}
        userStatus={user.status}
      />
      <SendReActivationEmail
        showModal={isSendReActivationEmailDialogOpen}
        handleClose={closeSendReActivationDialog}
        userId={user.id}
        userEmail={getEmail(user)}
        userStatus={user.status}
      />
      {
        isResetMultiFactorDialogOpen && <ResetMultiFactor
          showModal={isResetMultiFactorDialogOpen}
          handleClose={closeResetMultiFactorDialog}
          userId={user.id}
        />
      }
    </>
  );
};

KebabMenu.propTypes = {
  user: PropTypes.object,
}

KebabMenu.defaultProps = {
  user: {},
}

export default KebabMenu;
